<template>
  <VeeForm id="book-review-form" @submit="submit">
    <div class="mb-16">
      <label for="rating" class="form-label">
        {{ $label('books.reviews.score') }}
      </label>
      <VeeField
        v-slot="{ meta, field, errorMessage }"
        v-model="rating"
        name="rating"
        rules="required"
      >
        <input
          v-bind="field"
          id="rating"
          autocomplete="email"
          aria-describedby="email"
          class="star-input"
        />
        <StarsRating
          :rating="rating"
          :on-star-clicked="onStarClicked"
          render-stars-as-buttons
        />
        <div v-show="!meta.valid && meta.touched" class="invalid-feedback">
          {{ errorMessage }}
        </div>
      </VeeField>
    </div>

    <div class="mb-16 review-title">
      <label for="reviewTitle" class="form-label">
        {{ $label('books.reviews.reviewTitle') }}
      </label>

      <VeeField
        v-slot="{ meta, field, errorMessage }"
        v-model="reviewTitle"
        name="reviewTitle"
        rules="required"
      >
        <input
          v-bind="field"
          id="reviewTitle"
          type="text"
          :is-valid="meta.valid && meta.touched"
          :class="[
            'form-control',
            { 'is-valid': meta.valid && meta.touched },
            { 'is-invalid': !meta.valid && meta.touched }
          ]"
        />
        <div v-show="!meta.valid && meta.touched" class="invalid-feedback">
          {{ errorMessage }}
        </div>
      </VeeField>
    </div>

    <div class="mb-16">
      <label for="reviewDescription" class="form-label">
        {{ $label('books.reviews.reviewDescription') }}
      </label>

      <VeeField
        v-slot="{ meta, field, errorMessage }"
        v-model="reviewDescription"
        name="reviewDescription"
        rules="required"
      >
        <textarea
          v-bind="field"
          id="reviewDescription"
          rows="5"
          max-rows="6"
          :is-valid="meta.valid && meta.touched"
          :class="[
            'form-control',
            { 'is-valid': meta.valid && meta.touched },
            { 'is-invalid': !meta.valid && meta.touched }
          ]"
        />
        <div v-show="!meta.valid && meta.touched" class="invalid-feedback">
          {{ errorMessage }}
        </div>
      </VeeField>
    </div>
  </VeeForm>
</template>

<script>
import { useReviewsStore } from '~/stores/reviews'
import StarsRating from '~/components/reviews/StarsRating'

export default {
  components: {
    StarsRating
  },
  props: {
    bookSlug: {
      type: String,
      required: true
    },
    bookUid: {
      type: String,
      required: true
    },
    userUid: {
      type: String,
      required: true
    },
    setLoadingState: {
      type: Function,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    }
  },
  setup() {
    const reviewsStore = useReviewsStore()

    return {
      submitReview: reviewsStore.submitReview
    }
  },
  data() {
    return {
      rating: undefined,
      reviewTitle: '',
      reviewDescription: ''
    }
  },
  methods: {
    onStarClicked(value) {
      this.rating = value
    },
    async submit() {
      try {
        this.setLoadingState(true)

        const data = {
          bookSlug: this.bookSlug,
          bookUid: this.bookUid,
          userUid: this.userUid,
          rating: this.rating,
          reviewTitle: this.reviewTitle,
          reviewDescription: this.reviewDescription
        }

        await this.submitReview(data)

        this.resetForm()
      } catch (error) {
        let errorLabel = this.$error.getLabel(error)

        if (errorLabel === 'reviews.duplicateReview') {
          errorLabel = `books.${errorLabel}`
        } else {
          this.$sentryCaptureException(error)
        }

        this.$toast.error(this.$label(errorLabel))
      } finally {
        this.closeModal()
        this.setLoadingState(false)
      }
    },
    resetForm() {
      this.rating = 0
      this.reviewTitle = ''
      this.reviewDescription = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.star-input {
  display: none;
}

.review-title {
  max-width: 249px;
}
</style>
